import PropTypes from 'prop-types';

import { StyledStandardImage } from './styled.components';

export const StandardImage = ({
  src, alt, width, className
}) => (
  <StyledStandardImage
    src={src}
    alt={alt}
    width={width}
    className={className}
    useFullUrl={src.includes('http')}
  />
);

StandardImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  width: PropTypes.number,
  className: PropTypes.string
};

StandardImage.defaultProps = {
  alt: '',
  width: 500
};
